import { render, staticRenderFns } from "./updUserTaak.vue?vue&type=template&id=1183c4c5&scoped=true"
import script from "./updUserTaak.vue?vue&type=script&lang=js"
export * from "./updUserTaak.vue?vue&type=script&lang=js"
import style0 from "./updUserTaak.vue?vue&type=style&index=0&id=1183c4c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1183c4c5",
  null
  
)

export default component.exports